export const
    funnelTitleError = "Enter title of Funnel",
    funnelAuthorError = "Select author of Funnel",
    funnelCampaignIdError = "Select Campaign for Funnel",
    funnelTypeError = "Select type of Funnel",
    funnelOfferError = "Select offer of Funnel",
    funnelUpsaleError = "Select upsell of Funnel";
